import { HTML_LINK_PREFIX } from './constants';
export const getYearsOptions = (publicationYearModels) => {
    const years = publicationYearModels === null || publicationYearModels === void 0 ? void 0 : publicationYearModels.map(publicationYearModel => { var _a; return (_a = publicationYearModel === null || publicationYearModel === void 0 ? void 0 : publicationYearModel.yearModels) === null || _a === void 0 ? void 0 : _a.map(yearModel => yearModel === null || yearModel === void 0 ? void 0 : yearModel.year); }).flat();
    const uniqueYears = [...new Set(years)].sort((a, b) => +b - +a);
    return uniqueYears.map(year => ({
        value: year,
        text: year,
    }));
};
export const getCurrentYearModelsOptions = (currentYear, publicationYearModels) => {
    const models = publicationYearModels.flatMap(publicationYearModel => publicationYearModel.yearModels
        .filter(yearModel => yearModel.year === currentYear)
        .flatMap(yearModel => yearModel.models)
        .filter(model => model != null));
    const uniqueModels = [...new Set(models)].sort();
    return uniqueModels.map(model => ({ value: model, text: model }));
};
export const getPublicationTypes = (selectedYear, selectedModel, publicationYearModels) => publicationYearModels
    .filter(publication => publication.yearModels.some(yearModel => yearModel.year === selectedYear && (yearModel.models === null || yearModel.models.includes(selectedModel))))
    .map(publication => publication.publication);
/**
 * Filters a list of publication items based on specified publication types.
 *
 * @param publicationItems - An array of `ManualItem` objects to filter.
 * @param publicationTypes - An array of strings representing the publication types to filter by.
 * @returns An array of `ManualItem` objects where the `publicationTypeName.value` matches one of the
 * specified publication types.
 */
export const getManuals = (publicationItems, publicationTypes) => {
    if (!Array.isArray(publicationItems) || !publicationItems.length)
        return [];
    return publicationItems.filter(item => { var _a; return publicationTypes.includes((_a = item === null || item === void 0 ? void 0 : item.publicationTypeName) === null || _a === void 0 ? void 0 : _a.value); });
};
export const getHtmlLinks = ({ language, items, downloadFilePrefix }) => `${downloadFilePrefix}${HTML_LINK_PREFIX}${language === 'en' ? items.htmlBaseEn : items.htmlBaseFr}${language === 'en' ? items.fileEn : items.fileFr}`;
export const getPdfLink = ({ language, items, downloadFilePrefix }) => `${downloadFilePrefix}${language === 'en' ? items.fileEn : items.fileFr}`;
